import script from "./ApproveButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ApproveButton.vue?vue&type=script&setup=true&lang=js"

import "./ApproveButton.vue?vue&type=style&index=0&id=2b7ccb7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7ccb7a"]])

export default __exports__